import { useEffect, useMemo, useState } from 'react';
import { isEmpty } from 'lodash';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getSelectedVariant } from '../../../store/inventory/selector';
import { INITIAL_FORM } from '../data/inventory';
import { TTransferQuantity } from '../../../types';
import { getDiffBetweenNestedObj } from '../../../utils/helpers';

export function useTransferVariantLocation() {
  const selectedVariant = useAppSelector(getSelectedVariant);

  const [formInputs, setFormInputs] = useState(INITIAL_FORM);
  const [prevFormInputs, setPrevFormInputs] = useState(INITIAL_FORM);

  useEffect(() => {
    if (selectedVariant) {
      const variantData = {
        selectetVariant: selectedVariant.selectetVariant,
        targetLocation: selectedVariant.targetLocation,
        quantity: selectedVariant.quantity,
        selectedQuantityType: selectedVariant.selectedQuantityType,
      } as TTransferQuantity;

      setFormInputs(variantData);
      setPrevFormInputs(variantData);
    } else {
      setFormInputs(INITIAL_FORM);
    }
  }, [selectedVariant]);

  const getFormDetails = useMemo(() => ({
    ...formInputs,
  }), [formInputs]);

  const isEdited = useMemo(() => {
    const diff = getDiffBetweenNestedObj(formInputs, prevFormInputs);

    return !isEmpty(diff);
  }, [formInputs, prevFormInputs]);

  return {
    isEdited,
    getFormDetails,
    setFormInputs,
    formInputs,
  };
}
